import {
  FEEDBACKLIST
} from '../actions/feedback';
import {reducerPackage} from "../../utils";

export const feedbackList = reducerPackage(FEEDBACKLIST);

